import { HttpClient } from './client/httpClient';
import backendHttpClient from './client/backendHttpClient';
import { SmscModel, SmscObject } from '../models/smscModel';
import { SmscResponse } from './responses/smscResponse';
import { VersionableId } from '../types/versionableId';
import { ErrorHandler } from './error/errorHandler';
import apiErrorHandler from './error/apiErrorHandler';

class SmscApi {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandler: ErrorHandler) {}

  public fetchAllSmscByCommitId(commitId: string): Promise<SmscModel[]> {
    return this.httpClient.get<SmscResponse[]>(`/commits/${commitId}/SMSCs`)
      .then(response => response.map(it => this.mapToSmscModel(commitId, it)))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch all SMSCs by commit id'));
  }

  public fetchSmscConfigFile(smscId: VersionableId): Promise<string> {
    return this.httpClient.get<string>(`/commits/${smscId.commitId}/SMSCs/${smscId.resourceName}/config-file`)
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch config file for SMSC'));
  }

  public addSmsc(schemaName: string, smsc: SmscObject): Promise<void> {
    return this.httpClient.post<void>(`/schemas/${schemaName}/SMSCs`, smsc)
      .catch(error => this.errorHandler.handleError(error, 'Failed to add SMSC'));
  }

  public updateSmsc(schemaName: string, smscName: string, smsc: SmscObject): Promise<void> {
    return this.httpClient.put<void>(`/schemas/${schemaName}/SMSCs/${smscName}`, smsc)
      .catch(error => this.errorHandler.handleError(error, 'Failed to update SMSC'));
  }

  public deleteSmsc(schemaName: string, smscName: string): Promise<void> {
    return this.httpClient.delete<void>(`/schemas/${schemaName}/SMSCs/${smscName}`)
      .catch(error => this.errorHandler.handleError(error, 'Failed to delete SMSC'));
  }

  public generateSmscConfigFilePreview(smsc: SmscObject): Promise<string> {
    return this.httpClient.post<string>(`/config-files/smsc/preview`, smsc)
      .catch(error => this.errorHandler.handleError(error, 'Failed to generate config file for SMSC'));
  }

  private mapToSmscModel(commitId: string, smscResponse: SmscResponse): SmscModel {
    return {
      id: {
        commitId,
        resourceName: smscResponse.smscName,
      },
      object: {
        smscId: smscResponse.smscId,
        logFile: smscResponse.logFile,
        logLevel: smscResponse.logLevel,
        connections: smscResponse.connections,
      },
    };
  }

}

export default new SmscApi(backendHttpClient, apiErrorHandler);
